import { localAddresses } from '../localAddresses';
import { tokens } from '../../tokens/underlyingTokens';
import { ChainId, type VToken } from '../../types';

export const local: VToken[] = [
  {
    chainId: ChainId.LOCAL,
    address: localAddresses.vWTAO,
    decimals: 8,
    symbol: 'vWTAO',
    underlyingToken: tokens[ChainId.LOCAL][1]!,
  },
  {
    chainId: ChainId.LOCAL,
    address: localAddresses.vAlpha30,
    decimals: 8,
    symbol: 'vALPHA30',
    underlyingToken: tokens[ChainId.LOCAL][2]!,
  },
  {
    chainId: ChainId.LOCAL,
    address: localAddresses.vAlpha64,
    decimals: 8,
    symbol: 'vALPHA64',
    underlyingToken: tokens[ChainId.LOCAL][3]!,
  },
];
